<script setup lang="ts">
import type { SelectSeparatorProps } from 'reka-ui'
import type { HTMLAttributes } from 'vue'
import { SelectSeparator } from 'reka-ui'

const props = defineProps<SelectSeparatorProps & { class?: HTMLAttributes['class'] }>()
const appConfig = useAppConfig()
const delegatedProps = computed(() => {
  const { class: _, ...delegated } = props
  return delegated
})
</script>

<template>
  <SelectSeparator v-bind="delegatedProps" :class="cn(appConfig.ui.select.slots.separator, props.class)" />
</template>
